import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { Box, IconButton, TextField } from "@mui/material";
import { copyToClipboard } from "../utils/portalHelpers";

const CopyTextField = ({ label, value, copyMessage, multiline = false, rows = 2 }) => (
  <Box sx={{ display: "flex", gap: 1, alignItems: multiline ? "flex-start" : "center" }}>
    <TextField
      label={label}
      value={value || ""}
      fullWidth
      size="small"
      multiline={multiline}
      minRows={multiline ? rows : undefined}
      InputProps={{ readOnly: true }}
    />
    <IconButton
      color="primary"
      onClick={() => copyToClipboard(value, copyMessage)}
      disabled={!value}
      sx={{ mt: multiline ? 0.5 : 0 }}
    >
      <ContentCopyIcon />
    </IconButton>
  </Box>
);

export default CopyTextField;
